/* EMI payment-plan preview (draft mock). Reads amounts from the existing EMI wrap (paise) - no new price math beyond (price - today) / months, same as the live modal. Dates are ESTIMATES (today + n months) until the lender due-date rule is available. */
(function () {
  if (window.__epLoaded) return; window.__epLoaded = true;
  if (window.__emiPlanInit) return;
  window.__emiPlanInit = true;
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var rupee = function (n) { return '\u20B9' + Math.round(n).toLocaleString('en-IN'); };
  function addMonths(d, n) {
    /* EMI is taken on the 10th of every month; first payment is the 10th of next month (estimate). */
    return new Date(d.getFullYear(), d.getMonth() + n, 10);
  }
  function fd(d) { return d.getDate() + ' ' + MON[d.getMonth()]; }
  function readSource(card) {
    var sel = card.getAttribute('data-ep-source');
    var src = sel ? document.querySelector(sel) : null;
    if (!src) src = document.querySelector('[data-emi-unit-price]');
    var price = parseFloat((src && src.getAttribute('data-emi-unit-price')) || card.getAttribute('data-ep-price') || 0) / 100;
    var down = parseFloat((src && src.getAttribute('data-emi-downpayment')) || card.getAttribute('data-ep-down') || 0) / 100;
    var months = parseInt((src && src.getAttribute('data-emi-months')) || card.getAttribute('data-ep-months') || 3, 10);
    return { price: price, down: down, months: months };
  }
  /* Strike-off price: the variant's compare_at_price from the product JSON (paise), for the variant currently selected. Cached per product. */
  var PJ = {};
  function productJson() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/); if (!m) return null;
    var h = m[1];
    if (!PJ[h]) { PJ[h] = { v: null }; fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (j) { PJ[h].v = j.variants || []; }).catch(function () { PJ[h].v = []; }); }
    return PJ[h];
  }
  function variantId() {
    var q = location.search.match(/[?&]variant=(\d+)/); if (q) return q[1];
    var i = document.querySelector('form[action*="/cart/add"] [name="id"]'); return i ? i.value : '';
  }
  function compareAt(card) {
    if ((card.getAttribute('data-ep-source') || '').indexOf('product') < 0) return 0;
    var pj = productJson(); if (!pj || !pj.v) return 0;
    var id = variantId(), v = null;
    for (var i = 0; i < pj.v.length; i++) if (String(pj.v[i].id) === id) v = pj.v[i];
    return v && v.compare_at_price ? v.compare_at_price / 100 : 0;
  }
  function paint(card) {
    var s = readSource(card);
    if (!s.price) return;
    var cmp = compareAt(card); if (!(cmp > s.price)) cmp = 0;
    var key = s.price + '|' + s.down + '|' + s.months + '|' + cmp;
    if (card.__k === key) return;
    card.__k = key;
    /* Same rules as the live EMI button/modal: with a down payment, 3 monthly payments after it; with none, N total payments, the first one today (rounded up). */
    var n, down, m;
    if (s.down > 0) { n = 3; down = s.down; m = Math.round((s.price - down) / n); }
    else { n = Math.max(1, s.months - 1); m = Math.floor(s.price / s.months); down = s.price - n * m; }
    s.months = n;
    var now = new Date();
    var steps = '<li class="emi-plan__step emi-plan__step--now"><span class="emi-plan__dot">1</span><span class="emi-plan__when">Today<small>Pay now to confirm</small></span><span class="emi-plan__amt">' + rupee(down) + '</span></li>';
    for (var i = 1; i <= s.months; i++) {
      steps += '<li class="emi-plan__step"><span class="emi-plan__dot">' + (i + 1) + '</span><span class="emi-plan__when">' + fd(addMonths(now, i)) + '<small>Monthly payment ' + i + ' of ' + s.months + '</small></span><span class="emi-plan__amt">' + rupee(m) + '</span></li>';
    }
    var $ = function (q) { return card.querySelector(q); };
    $('[data-ep-steps]').innerHTML = steps;
    $('[data-ep-down]').textContent = rupee(down);
    var tot = card.querySelectorAll('[data-ep-total]'); for (var k = 0; k < tot.length; k++) tot[k].textContent = rupee(s.price);
    var tb = $('.emi-plan__total b');
    var old = card.querySelectorAll('.emi-plan__mrp,.emi-plan__save'); for (var o = 0; o < old.length; o++) old[o].parentNode.removeChild(old[o]);
    if (cmp && tb) {
      tb.insertAdjacentHTML('beforebegin', '<s class="emi-plan__mrp">' + rupee(cmp) + '</s>');
      var sv = document.createElement('div'); sv.className = 'emi-plan__save'; sv.textContent = 'You save ' + rupee(cmp - s.price);
      tb.closest('.emi-plan__total').insertAdjacentElement('afterend', sv);
    }
    var kd = $('[data-ep-k-down]'); if (kd) kd.textContent = rupee(down);
    var km = $('[data-ep-k-month]'); if (km) km.textContent = s.months + ' \u00D7 ' + rupee(m);
    card.hidden = false;
    var lk = document.querySelector('.emi-planlink__txt'); if (lk && card.getAttribute('data-ep-source').indexOf('product') > -1) lk.textContent = 'Pay ' + rupee(down) + ' today, then ' + n + ' monthly payments';
  }
  function paintTiles() {
    var els = document.querySelectorAll('[data-ep-tile]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__done) continue;
      var price = parseFloat(el.getAttribute('data-price')) / 100, down = parseFloat(el.getAttribute('data-down')) / 100;
      if (!price) continue;
      if (!(down > 0)) { el.style.display = 'none'; el.__done = true; continue; }
      var m = Math.round((price - down) / 3);
      el.querySelector('[data-ep-t-today]').textContent = rupee(down);
      el.querySelector('[data-ep-t-month]').textContent = rupee(m);
      el.querySelector('[data-ep-t-full]').textContent = rupee(price);
      el.__done = true;
    }
  }
  var ARROW = '<svg class="icon" width="17" height="16" viewBox="0 0 17 16" fill="none"><path d="M7.04688 3.63647L11.4105 8.00011L7.04687 12.3637" stroke="currentColor" stroke-width="1.09091" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function setOpen(w, open) {
    var btn = w.querySelector('.about__accordion-toggle'), body = w.querySelector('.emi-about__body');
    btn.classList.toggle('active', open); btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    body.style.display = open ? 'block' : 'none';
  }

  /* Mobile only: after "View plan", shake the sticky Buy-on-EMI button for up to 10s or until the user scrolls/touches. Transform only, so layout never moves. */
  var nudgeTimer = null, nudgeOff = null;
  function nudgeBuy() {
    var wrap = document.querySelector('.emi-checkout-template-wrap[data-emi-location="product"]');
    var btn = wrap && wrap.querySelector('.emi-checkout-template');
    if (!btn || window.innerWidth >= 750 || getComputedStyle(wrap).position !== 'fixed') return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (nudgeOff) nudgeOff();
    btn.classList.add('emi-nudge');
    var armed = false, arm = setTimeout(function () { armed = true; }, 1600);
    function off() {
      btn.classList.remove('emi-nudge'); clearTimeout(nudgeTimer); clearTimeout(arm);
      ['touchstart', 'touchmove', 'wheel', 'keydown'].forEach(function (t) { window.removeEventListener(t, off, true); });
      window.removeEventListener('scroll', onScroll, true); nudgeOff = null;
    }
    function onScroll() { if (armed) off(); }
    ['touchstart', 'touchmove', 'wheel', 'keydown'].forEach(function (t) { window.addEventListener(t, off, { capture: true, passive: true }); });
    window.addEventListener('scroll', onScroll, { capture: true, passive: true });
    nudgeOff = off; nudgeTimer = setTimeout(off, 10000);
  }
  /* About the product: turn the plain description into structured, scannable content (generic: reads whatever the product description holds). */
  var TICK = '<svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function designAbout() {
    var host = document.querySelector('#about-product .about__accordion-description');
    if (!host || host.__emi) return;
    host.__emi = true;
    var aboutWrap = host.closest('.about');
    if (!host.textContent.replace(/\s+/g, '').length && !host.querySelector('img,iframe,video')) { if (aboutWrap) aboutWrap.style.display = 'none'; return; }
    var story = [], feats = [], specs = [], seen = {};
    var tables = host.querySelectorAll('table tr');
    for (var i = 0; i < tables.length; i++) {
      var th = tables[i].querySelector('th'), td = tables[i].querySelector('td');
      if (th && td && td.textContent.trim()) specs.push([th.textContent.trim(), td.textContent.trim()]);
    }
    var lis = host.querySelectorAll('li');
    for (var j = 0; j < lis.length; j++) { var lt = lis[j].textContent.trim(); if (lt) feats.push(lt); }
    var ps = host.querySelectorAll('p');
    for (var k = 0; k < ps.length; k++) {
      var t = ps[k].textContent.replace(/\s+/g, ' ').trim(); if (!t) continue;
      var m = t.match(/^(.*?)(?:Details\s*:\s*)(.*)$/i);
      var head = m ? m[1] : t, det = m ? m[2] : '';
      head = head.replace(/^\s*Product Story\s*:\s*/i, '').trim();
      if (head) story.push(head);
      if (det) det.split(/,\s*/).forEach(function (it) {
        it = it.trim().replace(/\.$/, ''); if (!it) return;
        var kv = it.match(/^([^:]{2,30}):\s*(.+)$/);
        if (kv) specs.push([kv[1].trim(), kv[2].trim()]); else feats.push(it);
      });
    }
    if (!host.querySelector('p,li,table,h2,h3,h4,div,ul,ol')) { var bare = host.textContent.replace(/\s+/g, ' ').trim(); if (bare) story.push(bare); }
    var uniq = [];
    specs.forEach(function (p) { var key = p[0].toLowerCase(); if (!seen[key]) { seen[key] = 1; uniq.push(p); } });
    if (!story.length && !feats.length && !uniq.length) return;
    var h = '<div class="emi-ab">';
    if (story.length) h += '<div class="emi-ab__sec"><h4 class="emi-ab__h">Product story</h4><p class="emi-ab__story' + (story.join(' ').length > 200 ? ' is-clamped' : '') + '">' + esc(story.join(' ')) + '</p>' + (story.join(' ').length > 200 ? '<button type="button" class="emi-ab__more" data-ab-story>Read more</button>' : '') + '</div>';
    if (feats.length) {
      var shortF = feats.filter(function (f) { return f.length <= 45; }), longF = feats.filter(function (f) { return f.length > 45; });
      h += '<div class="emi-ab__sec"><h4 class="emi-ab__h">Key features</h4>';
      if (shortF.length) { h += '<ul class="emi-ab__chips">'; shortF.forEach(function (f) { h += '<li>' + TICK + esc(f) + '</li>'; }); h += '</ul>'; }
      if (longF.length) {
        h += '<ul class="emi-ab__rows">';
        longF.forEach(function (f) {
          var c = f.indexOf(':'), lab = '', desc = f;
          if (c > 2 && c <= 40) { lab = f.slice(0, c).trim(); desc = f.slice(c + 1).trim(); }
          h += '<li>' + TICK + '<div>' + (lab ? '<b>' + esc(lab) + '</b>' : '') + (desc ? '<span>' + esc(desc) + '</span>' : '') + '</div></li>';
        });
        h += '</ul>';
      }
      h += '</div>';
    }
    if (uniq.length) {
      h += '<div class="emi-ab__sec"><h4 class="emi-ab__h">Specifications</h4><dl class="emi-ab__specs">';
      uniq.forEach(function (p, n) { h += '<div class="emi-ab__spec' + (n >= 6 ? ' is-extra' : '') + '"><dt>' + esc(p[0]) + '</dt><dd>' + esc(p[1]) + '</dd></div>'; });
      h += '</dl>';
      if (uniq.length > 6) h += '<button type="button" class="emi-ab__more" data-ab-specs>Show all ' + uniq.length + ' specifications</button>';
      h += '</div>';
    }
    h += '</div>';
    var orig = document.createElement('div'); orig.hidden = true; orig.className = 'emi-ab__orig'; orig.innerHTML = host.innerHTML;
    host.innerHTML = h; host.appendChild(orig);
    host.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.emi-ab__more'); if (!b) return;
      e.stopPropagation();
      if (b.hasAttribute('data-ab-story')) { var p = host.querySelector('.emi-ab__story'); var c = p.classList.toggle('is-clamped'); b.textContent = c ? 'Read more' : 'Show less'; }
      else { var d = host.querySelector('.emi-ab__specs'); var o = d.classList.toggle('is-open'); b.textContent = o ? 'Show fewer' : 'Show all ' + d.children.length + ' specifications'; }
    });
  }
  function place() {
    if (document.querySelector('.emi-about')) return;
    var card = document.querySelector('[data-ep-card][data-ep-source*="product"]'), tr = document.querySelector('.emi-trust');
    var abouts = document.querySelectorAll('.about'), anchor = abouts.length ? abouts[abouts.length - 1] : null;
    var b = document.querySelector('.product__buy-buttons');
    if (!card || !tr || !anchor || !b) return;
    var w = document.createElement('div'); w.className = 'about emi-about';
    w.innerHTML = '<div class="about__accordion-item"><button type="button" class="about__accordion-toggle button--unstyled" aria-expanded="false"><div class="about__accordion-toggle-title"><span>Payment plan</span></div><div class="about__accordion-toggle-arrow">' + ARROW + '</div></button><div class="about__accordion-description small-font emi-about__body" style="display:none"></div></div>';
    var body = w.querySelector('.emi-about__body'); body.appendChild(card);
    anchor.insertAdjacentElement('afterend', w); w.insertAdjacentElement('afterend', tr);
    w.querySelector('.about__accordion-toggle').addEventListener('click', function (e) { e.stopPropagation(); setOpen(w, w.querySelector('.emi-about__body').style.display === 'none'); }, true);
    var lk = document.createElement('button'); lk.type = 'button'; lk.className = 'emi-planlink';
    lk.innerHTML = '<span class="emi-planlink__txt">Pay today, then 3 monthly payments</span><span class="emi-planlink__cta">View plan<svg viewBox="0 0 16 16" fill="none"><path d="M6 3.5L10.5 8L6 12.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
    lk.addEventListener('click', function () { setOpen(w, true); w.scrollIntoView({ behavior: 'smooth', block: 'start' }); nudgeBuy(); });
    b.insertAdjacentElement('afterend', lk);
    card.__k = null;
  }
  /* Buy bar copy: no "From" - the amount is exact. PDP: "Pay just X today" + "then 3 x Y" (own elements, originals hidden by CSS). Cart: drop "From". */
  function payCopy() {
    var ws = document.querySelectorAll('.emi-checkout-template-wrap');
    for (var i = 0; i < ws.length; i++) {
      var w = ws[i], c = w.querySelector('.emi-checkout-template__content'), btn = w.querySelector('.emi-checkout-template');
      if (!c) continue;
      var isProd = w.getAttribute('data-emi-location') === 'product';
      var cT = w.getAttribute('data-emi-cart-today'), cM = w.getAttribute('data-emi-cart-monthly');
      var isCart = !isProd && cT !== null && cM !== null && parseFloat(cM) > 0;
      if (!isProd && !isCart) {
        var fr = c.querySelector('.emi-checkout-template__from'); if (fr) fr.style.display = 'none';
        if (btn) { var al = btn.getAttribute('aria-label') || ''; if (/, from /i.test(al)) btn.setAttribute('aria-label', al.replace(/, from /i, ', ')); }
        continue;
      }
      var pr = parseFloat(w.getAttribute('data-emi-unit-price') || 0) / 100;
      var dp = parseFloat(w.getAttribute('data-emi-downpayment') || 0) / 100;
      var mo = parseInt(w.getAttribute('data-emi-months') || 3, 10);
      if (!pr && !isCart) continue;
      var n, m, today;
      if (isCart) { n = 3; today = parseFloat(cT); m = parseFloat(cM); }
      else if (dp > 0) { n = 3; today = dp; m = Math.round((pr - dp) / n); }
      else { n = Math.max(1, mo - 1); m = Math.floor(pr / mo); today = pr - n * m; }
      var mine = c.querySelector('.emi-pay');
      if (!mine) {
        mine = document.createElement('span'); mine.className = 'emi-pay';
        mine.innerHTML = '<span class="emi-checkout-template__from">Pay just</span><span class="emi-checkout-template__amount-row"><span class="emi-checkout-template__amount" data-pay-today></span><span class="emi-checkout-template__tenure" data-pay-then></span></span>';
        var row = c.querySelector('.emi-checkout-template__amount-row');
        if (row) row.insertAdjacentElement('afterend', mine); else c.appendChild(mine);
        c.classList.add('emi-pay-on');
      }
      mine.querySelector('[data-pay-today]').textContent = rupee(today) + ' today';
      mine.querySelector('[data-pay-then]').innerHTML = 'then ' + rupee(m) + ' <b>\u00D7 ' + n + ' months</b>';
      if (btn) btn.setAttribute('aria-label', 'Buy on EMI with Velocity. Pay just ' + rupee(today) + ' today, then ' + n + ' monthly payments of ' + rupee(m));
    }
  }
  /* Velocity Bazaar / Velocity Club lines (text only). */
  function clubLines() {
    var mk = function (cls, txt) { var p = document.createElement('p'); p.className = 'emi-clubline ' + cls; p.textContent = txt; return p; };
    var l = document.querySelector('.emi-trust__lender');
    if (l && !document.querySelector('.emi-clubline--trust')) l.insertAdjacentElement('afterend', mk('emi-clubline--trust', 'Every Velocity Bazaar purchase makes you a Velocity Club member.'));
    var c = document.querySelector('.emi-checkout-template-wrap[data-emi-location="cart-page"]');
    if (c && !document.querySelector('.emi-clubline--cart')) c.insertAdjacentElement('afterend', mk('emi-clubline--cart', 'Every Velocity Bazaar purchase makes you a Velocity Club member.'));
    var f = document.querySelector('footer.footer');
    if (f && !document.querySelector('.emi-clubline--footer')) {
      var w = document.createElement('div'); w.className = 'emi-clubfoot page-width';
      w.appendChild(mk('emi-clubline--footer', 'Velocity Bazaar - a Velocity Club experience'));
      f.appendChild(w);
    }
  }
  /* Homepage: one quiet welcome block directly below the EMI strip. Generic copy, no amounts. */
  function welcome() {
    var strip = document.querySelector('[id$="__emi_plan_strip"]');
    if (!strip || document.querySelector('.emi-welcome')) return;
    /* Sits after the Electronics list (falls back to right after the EMI strip if that section is missing). */
    var sec = strip, secs = document.querySelectorAll('.shopify-section.popular-products-section');
    for (var q = 0; q < secs.length; q++) { var hd = secs[q].querySelector('h4'); if (hd && /^\s*electronics/i.test(hd.textContent)) sec = secs[q]; }
    var T = '<svg viewBox="0 0 16 16" fill="none"><path d="M3 8.5l3.2 3.2L13 4.8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var d = document.createElement('div'); d.className = 'emi-welcome';
    d.innerHTML = '<div class="emi-welcome__inner"><div class="emi-welcome__main"><p class="emi-welcome__eyebrow">Velocity Club</p><h2 class="emi-welcome__title">Welcome to Velocity Bazaar</h2>' +
      '<p class="emi-welcome__sub">Pay just a small amount today and split the rest into monthly payments. Payments are deducted automatically, so there is nothing to track or remember.</p></div>' +
      '<div class="emi-welcome__side"><ul class="emi-welcome__perks"><li>' + T + 'Exclusive brands</li><li>' + T + 'Exclusive deals</li></ul>' +
      '<p class="emi-welcome__foot">Every purchase from any Velocity store makes you a Velocity Club member.</p>' +
      '<a class="emi-welcome__cta" href="/collections/split-sale-items">Explore the Bazaar<svg viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></a></div></div>';
    sec.insertAdjacentElement('afterend', d);
  }
  function all() {
    place();
    welcome();
    clubLines();
    payCopy();
    designAbout();
    var cards = document.querySelectorAll('[data-ep-card]');
    for (var i = 0; i < cards.length; i++) paint(cards[i]);
    paintTiles();
  }
  document.addEventListener('DOMContentLoaded', all);
  window.addEventListener('load', all);
  setInterval(all, 1000);
})();
